import React from 'react';
import PropTypes from 'prop-types';
import Swiper, { SwiperClick, SwiperArrowType } from '@deporvillage/swiper-component';
import Picture, { cdn } from '@deporvillage/picture-component';
import { Config } from '@deporvillage/utils-library-component';
import Fullscreen from './Fullscreen';
import ImageZoom from './ImageZoom';
import Thumbnails from './Thumbnails';

import styles from './ProductGallery.module.scss';

const ProductGalleryClick = { 
    Main: 'main',
    SwiperNext: 'next',
    SwiperPrev: 'prev',
    SwiperPagination: 'pagination',
    Thumbnail: 'thumbnail',
};

const ProductGallery = ({ images, onClick }) => {

    const collection = images.images;
    const { isMobile, cdn: cdnConfig } = React.useContext(Config);

    const [state, setState] = React.useState({
        activeImage: images.default,
        fullscreen: false,
        zoom: false,
        backgroundImage: `url(${cdn({ src: `product/${collection[images.default]}` }, cdnConfig,)})`,
    });

    const changeImage = (idx) => setState({
        ...state,
        zoom: false,
        activeImage: idx,
        image: `product/${collection[idx]}`,
    });

    const handleViewGalleryClick = (e) => {
        switch (e) {
            case SwiperClick.PREV:
                onClick && onClick(ProductGalleryClick.SwiperPrev);
                break;
            case SwiperClick.NEXT:
                onClick && onClick(ProductGalleryClick.SwiperNext);
                break;
            case SwiperClick.PAGINATION:
                onClick && onClick(ProductGalleryClick.SwiperPagination);
                break;
        }
    };

    const handleOnThumbHover = (idx) => changeImage(idx);
    const handleOnThumbClick = () => onClick && onClick(ProductGalleryClick.Thumbnail);
    const handleOnCloseFullscreen = ({ activeImage }) => setState({ ...state, activeImage, fullscreen: false });

    const handleViewImageClick = (idx) => {
        onClick && onClick(ProductGalleryClick.Main);
        setState({
            ...state,
            zoom: false,
            fullscreen: true,
            activeImage: idx,
        });
    };

    return (
        <div className={styles['product-gallery-component']}>
            {
                state.fullscreen && (
                    <Fullscreen
                        initial={+state.activeImage}
                        collection={collection}
                        onClick={handleViewGalleryClick}
                        onClose={handleOnCloseFullscreen}
                    />
                )
            }

            {
                !isMobile ? (
                    <div className={styles.content}>

                        {
                            collection.length > 1 && (
                                <div className={styles['side-gallery']}>
                                    <Thumbnails
                                        collection={collection}
                                        onClick={handleOnThumbClick}
                                        onHover={handleOnThumbHover}
                                        size={75}
                                    />
                                </div>
                            )
                        }

                        <ImageZoom
                            image={collection[state.activeImage]}
                            size={575}
                            zoomSize={1350}
                            onClick={() => handleViewImageClick(state.activeImage)}
                            zoomOnHover
                            showBorder
                        />

                    </div>
                ) : (
                    <div>
                        <Swiper
                            initial={state.activeImage}
                            arrows={collection.length > 1 ? SwiperArrowType.In : SwiperArrowType.None}
                            pagination={collection.length > 1}
                            bullets={3}
                            lazy
                            loop
                        >
                            {
                                collection.map((i, idx) => (
                                    <div
                                        className={styles['main-gallery-mobile']}
                                        key={`Picture${idx}`}
                                        data-testid='click-to-open-mobile'
                                        onClick={() => handleViewImageClick(idx)}
                                    >
                                        <Picture
                                            sizes={{
                                                360: '330x330',
                                                500: '470x470',
                                            }}
                                            data-idx={idx}
                                            name={`Picture${idx}`}
                                            src={`product/${i}`}
                                            lazy
                                            width={576}
                                            height={576}
                                        />
                                    </div>
                                ))
                            }
                        </Swiper>
                    </div>
                )
            }
        </div>
    );
}
ProductGallery.propTypes = {
    images: PropTypes.shape({
        default: PropTypes.number,
        images: PropTypes.arrayOf(PropTypes.string),
    }),
    onClick: PropTypes.func,
};

export default ProductGallery;
export { ProductGalleryClick };
